/** GA4 event helper. No-ops when gtag is absent (ad blockers, tests, SSR). Never pass PII in params. */
export function track(name, params = {}) {
  try {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const clean = {};
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === null || v === "") continue;
      if (/email|phone|name|gstin|password|token/i.test(k)) continue;   // belt and braces: never ship PII keys
      clean[k] = typeof v === "number" || typeof v === "boolean" ? v : String(v).slice(0, 100);
    }
    window.gtag("event", name, clean);
  } catch { /* analytics must never break the app */ }
}
